export const paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
export const paypalCurrency = process.env.REACT_APP_PAYPAL_CURRENCY || 'USD';
